import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NotificationNORM_AGGREGATE } from '../../../../../../interfaces/notificationT';

@Component({
  selector: 'app-notification-norm-aggregate',
  templateUrl: './notification-norm-aggregate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationNormAggregateComponent implements OnInit {
  @Input() notification: NotificationNORM_AGGREGATE;

  constructor() {
  }

  ngOnInit() {
  }

}
